module.exports = __webpack_public_path__ + "img/about_home.c52e3b8d.jpg";